export const IconValidPassword = (props) => (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8092 5.40625L7.40035 13.8151L3.57812 9.99292"
      stroke="#29CC6A"
      strokeWidth="1.72"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
